import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Popover, Button, Table } from 'react-bootstrap'
import swal from 'sweetalert'
import axios from 'axios'

import { handleErrorFetchingData } from '../../functions/errorHandling'
import getServerURL from '../../functions/getServerURL'

import Document from './Document'

import FileUploader from '../file-uploading/FileUploader'

class Documentation extends Component {

  state = {
    filesForUpload: [],
  }

  handleFileDrop = (filesForUpload) => {
    filesForUpload = filesForUpload.map(file => {
      return { file, category: '' }
    })
    this.setState({ filesForUpload })
  }

  removeFile = (file, index) => {
    let { filesForUpload } = this.state
    filesForUpload = [...filesForUpload.slice(0, index), ...filesForUpload.slice(index + 1)]
    this.setState({ filesForUpload })
  }

  handleCategoryUpdate = (event, index) => {

    const category = event.target.value

    let { filesForUpload } = this.state
    const file = {...this.state.filesForUpload[index], category }
    filesForUpload = [...filesForUpload.slice(0, index), file, ...filesForUpload.slice(index + 1)]
    this.setState({ filesForUpload })
  }

  handleFileUpload = (file, index) => {

    const { parentElement, parentElementName, route } = this.props

    if (file.category.length === 0) {
      return swal({
        title: "Error",
        text: "Please enter a category",
        icon: "error",
        button: "Continue",
      })
    }

    if (file.category.length > 255) {
      return swal({
        title: "Error",
        text: "Category length must not exceed 255 characters",
        icon: "error",
        button: "Continue",
      })
    }

    swal({
      text: "Uploading file... Please stand by.",
      icon: require("../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })

    const currentUser = this.props.currentUser.url

    let newProposalDocument = new FormData()
    newProposalDocument.append('document', file.file)
    newProposalDocument.append('name', file.file.name)
    newProposalDocument.append('size', file.file.size)
    newProposalDocument.append('category', file.category)
    newProposalDocument.append(parentElementName, parentElement.url)
    newProposalDocument.append('created_by', currentUser)

    axios({
      method:"POST",
      data: newProposalDocument,
      url: `${getServerURL()}${route}/`,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
    })
    .then(response => {
      swal({
        title: "Success",
        text: "The file has been uploaded",
        icon: "success",
        button: "Continue",
      })

      this.props.addUploadedDocument(response.data)

      let { filesForUpload } = this.state

      filesForUpload = [...filesForUpload.slice(0, index), ...filesForUpload.slice(index + 1)]

      this.setState({ filesForUpload })
    })
    .catch(error => {
      const message = "There was an error uploading the file"
      return handleErrorFetchingData(error, message)
    })
  }

  renderDeletePopover = (doc) => {
    return (
      <Popover id="popover-basic" title="Delete Document">
        Are you sure you want to delete this document?
        <br/><br/>
        <strong>This action is irreversible.</strong>
        <br/><br/>
        <center>
          <Button
            bsStyle="danger"
            onClick={() => this.props.deleteUploadedDocument(doc)}
          >
            Delete
          </Button>
        </center>
      </Popover>
    )
  }

  render() {
    const { parentElement, parentElementName } = this.props

    let documents = parentElement.documents

    documents = documents.sort((a, b) => a.category.localeCompare(b.category))

    let categories = documents.map(doc => doc.category)

    categories = Array.from(new Set(categories))

    return (
      <div id="Documentation">
        {documents && documents.length === 0 ? <center>
            <h4>No documents have been uploaded for this {parentElementName}</h4>
          </center>
          :
          <Fragment>
            <center>
              <h4>Documents</h4>
            </center>
            <Table responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Size</th>
                  <th>Category</th>
                  <th></th>
                </tr>
               </thead>
               <tbody
               style={{border:"solid thin #F5F6F6", overflow:"scroll", height:"50%"}}
               >
              {documents.map(doc => {
                return (
                  <Document
                    key={doc.id}
                    document={doc}
                    categories={categories}
                    renderDeletePopover={this.renderDeletePopover}
                    editUploadedDocument={this.props.editUploadedDocument}
                  />
                )
              })}
            </tbody>
            </Table>
          </Fragment>
        }
        <br/><br/>
        <FileUploader
          allowMultiple={true}
          handleFileDrop={this.handleFileDrop}
          filesForUpload={this.state.filesForUpload}
          categories={categories}
          removeFile={this.removeFile}
          handleFileUpload={this.handleFileUpload}
          handleCategoryUpdate={this.handleCategoryUpdate}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps)(Documentation)



// WEBPACK FOOTER //
// ./src/reuseable-components/documentation/Documentation.js